export const JSON_Bank_Ifcs8 = {
    "code":"0x0200",
    "message":"Record fetched successfully.",
    "status":"SUCCESS",
    "data":{
        "requestId":"VBNK282988243721545177FD"
    }
};

export const JSON_Bank_Ifcs9 = {
    "code":"0x0202",
    "status":"FAILURE",
    "message":"Insufficient funds"
}
